import React from 'react';
import { PersonInterface } from '../person/person.interface';
import { QuoteBlockSideEnum } from '../quote-block/quote-block.interface';

export enum ArticleContentTypeEnum {
  QUOTE = 'quote',
  VIDEO = 'video',
}

interface ArticleContentCommonInterface {
  type: ArticleContentTypeEnum;
  data: Record<string, any>;
}

interface ArticleContentQuoteInterface extends ArticleContentCommonInterface {
  type: ArticleContentTypeEnum.QUOTE;
  data: {
    title?: string
    text: string;
    subtext?: string;
    aside?: string | PersonInterface;
    side?: QuoteBlockSideEnum;
  };
}

interface ArticleContentVideoInterface extends ArticleContentCommonInterface {
  type: ArticleContentTypeEnum.VIDEO;
  data: {
    videoUrl: string;
    caption: string;
  };
}

export type ArticleContentInterface = Array<
  ArticleContentQuoteInterface
  | ArticleContentVideoInterface
>;

export type ArticleBlockInterface = {
  title: string;
  content: ArticleContentInterface;
} & React.HTMLAttributes<HTMLElement>;
